import { Box, Button, Stack } from '@mui/material'
import { FeatureNameEnum } from '@ulysses-inc/harami_api_client'
import { useHistory } from 'react-router-dom'
import { useFeature } from 'src/features/featureFlags/useFeatureFlags'
import ErrorBoundary from 'src/libraries/ErrorBoundary'
import { LabelMasterList } from './LabelMasterList'
import { ListControls } from './ListControls'
import { PageHeader } from './PageHeader'
import { useTableFilters } from './useTableFilters'

export const LabelMasterListPage = () => {
  const history = useHistory()
  const { canUse: canUseBarcodeExtractionRule } = useFeature(
    FeatureNameEnum.BARCODE_EXTRACTION_RULE,
  )
  const {
    query,
    keyword,
    keywordError,
    setKeyword,
    page,
    rowsPerPage,
    handleChangePage,
    handleChangeRowsPerPage,
    handleConfirmKeyword,
  } = useTableFilters()

  return (
    <Stack
      height="calc(100vh - var(--banner-height, 0px))"
      bgcolor="background.grayLight"
      gap={2}
    >
      <PageHeader title="ラベルマスタ">
        {canUseBarcodeExtractionRule === 'yes' && (
          <Button
            variant="contained"
            color="secondary"
            onClick={() => history.push('/labelMasters/barcodeSetting')}
          >
            設定
          </Button>
        )}
      </PageHeader>
      <Box flex={1} overflow="hidden">
        <Box
          sx={{
            height: '100%',
            display: 'grid',
            gridTemplateRows: 'auto 1fr auto',
            gap: 2,
          }}
        >
          <ListControls
            keyword={keyword}
            keywordError={keywordError}
            onChangeKeyword={setKeyword}
            onSearch={handleConfirmKeyword}
          />

          {!keywordError && (
            <ErrorBoundary simple>
              <LabelMasterList
                query={query}
                page={page}
                rowsPerPage={rowsPerPage}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
            </ErrorBoundary>
          )}
        </Box>
      </Box>
    </Stack>
  )
}
